import * as Sentry from "@sentry/react";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import { loadingSettings, loadingSettingsDone, setSettings } from "./slice.js";

export const fetchSettings = () => async (dispatch, getState) => {
  dispatch(loadingSettings());

  const localAxios = createLocalAxios(getState);

  let response;
  try {
    response = await localAxios.get("settings");
  } catch (error) {
    console.error("Error while fetching the settings:", error);
    Sentry.captureException(error);
    throw error;
  } finally {
    dispatch(loadingSettingsDone());
  }

  dispatch(setSettings(response.data.settings));

  return response.data;
};

export const saveSettings = (settings) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);

  let response;
  try {
    response = await localAxios.patch("settings", settings);
  } catch (error) {
    console.error("Error while saving the settings:", error);
    Sentry.captureException(
      new Error(`Something went wrong: saveSettings put -> ${error}`),
    );
    throw error;
  }

  if (response.data.message !== apiMessages.MSG_SUCCESS) {
    throw new Error(response.data.message);
  }

  dispatch(setSettings(response.data.settings));

  return response;
};
